import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionParticipacionVinculacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionParticipacionVinculacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionParticipacionVinculacionService(): Observable<BodyListResponse<EstadoRevisionParticipacionVinculacionDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionParticipacionVinculacionDTO>>(API_URL + '/api/v1/estadoRevisionParticipacionVinculacion/todos');
  }

  guardarEstadoRevisionParticipacionVinculacionService(estadoRevisionParticipacionVinculacionDTO: EstadoRevisionParticipacionVinculacionDTO): Observable<EstadoRevisionParticipacionVinculacionDTO> {
    return this.http.post<EstadoRevisionParticipacionVinculacionDTO>(API_URL + '/api/v1/estadoRevisionParticipacionVinculacion', estadoRevisionParticipacionVinculacionDTO);
  }

  getEstadoRevisionParticipacionVinculacionPorCodigoRevisionParticipacionVinculacionService(codigoRevisionParticipacionVinculacion: string): Observable<BodyResponse<EstadoRevisionParticipacionVinculacionDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionParticipacionVinculacionDTO>>(API_URL + '/api/v1/estadoRevisionParticipacionVinculacion/' + codigoRevisionParticipacionVinculacion);
  }
  getEstadoRevisionParticipacionVinculacionPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionParticipacionVinculacionDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionParticipacionVinculacionDTO>>(API_URL + '/api/v1/estadoRevisionParticipacionVinculacion/persona/' + codigoPersona);
  }


}
